import { render, staticRenderFns } from "./OvisViewer.html?vue&type=template&id=e1138e78&scoped=true&"
import script from "./OvisViewer.vue?vue&type=script&lang=js&"
export * from "./OvisViewer.vue?vue&type=script&lang=js&"
import style0 from "./OvisViewer.scss?vue&type=style&index=0&id=e1138e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1138e78",
  null
  
)

export default component.exports